export function getFullOffsetOfElement(element: HTMLElement): number {
  return element && element.offsetParent
    ? element.offsetTop + getFullOffsetOfElement(element.offsetParent as HTMLElement)
    : 0
}
